import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {BooKingservice} from "./booking/booking.service";
import {FoEventsService} from "./event/foevents.service";
import {NavigationEnd, Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {isPlatformBrowser} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {FonctionUtiles} from "./fonctionsUtiles";

@Component({
  selector: 'app-fo',
  templateUrl: './fo.component.html',
  styleUrls: ['./fo.component.css'],
  providers: [BooKingservice]
})
export class FOComponent implements OnInit {
  hideSiteControls :boolean = false;
  constructor(public functionUtils:FonctionUtiles,private translate: TranslateService,private bookingservice: BooKingservice,private router: Router,@Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    this.translate.use(this.functionUtils.retrieve('curentLang') || 'fr');
    if (isPlatformBrowser(this.platformId) && localStorage != undefined) {
        let url_string = window.location.href;
        let url = new URL(url_string);
        if(url.searchParams.get("id3") && url_string.includes('booking/payment')) {
          this.bookingservice.iSId3Confirm = true;
          setTimeout(() => {
            this.bookingservice.iSId3Confirm = false;
          },9000);
        }
      //this.bookingservice.store('inscriptionIframe',true);
       if (this.bookingservice.retrieve('embeded')) {
          this.hideSiteControls = true;
        }

      /*if(environment.iframe)  {
        this.hideSiteControls = true;
        this.bookingservice.store('embededMode',true);
        this.bookingservice.removeItem('inscriptionIframe');
      }*/

      if (url_string.indexOf("links") > -1) {
        this.hideSiteControls = true;
      }
    }
  /*  let url_string = window.location.href;
    let url = new URL(url_string);*/
    /*
        if (url_string.indexOf("home") > -1) {
          this.bookingservice.removeItem('inscriptionIframe');
          this.bookingservice.removeItem('embededMode');
        }
    */
  }
  checkId3Confirm() {
    return this.bookingservice.iSId3Confirm;
  }
}
